export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const SET_INITIAL_FILTERS = 'SET_INITIAL_FILTERS';
export const SET_SESSION_DATE = 'SET_SESSION_DATE';
export const SET_ADDITIONAL_QUERY_PARAMS = 'SET_ADDITIONAL_QUERY_PARAMS';
export const FETCH_USERS_STARTED = 'FETCH_USERS_STARTED';
export const FETCH_USERS_SUCCEEDED = 'FETCH_USERS_SUCCEEDED';
export const OWNERS_FETCH_STARTED = 'OWNERS_FETCH_STARTED';
export const OWNERS_FETCH_SUCCEEDED = 'OWNERS_FETCH_SUCCEEDED';
export const FETCH_TEAMS_STARTED = 'FETCH_TEAMS_STARTED';
export const FETCH_TEAMS_SUCCEEDED = 'FETCH_TEAMS_SUCCEEDED';
export const DEALS_FETCH_STARTED = 'DEALS_FETCH_STARTED';
export const DEALS_FETCH_SUCCEEDED = 'DEALS_FETCH_SUCCEEDED';
export const DEALS_FETCH_FAILED = 'DEALS_FETCH_FAILED';
export const SET_DEAL_TABLE_PAGINATION = 'SET_DEAL_TABLE_PAGINATION';
export const SET_DEAL_TABLE_SORT = 'SET_DEAL_TABLE_SORT';
export const SET_SHOW_SUBMISSION_PANEL_FROM_DEAL_TABLE = 'SET_SHOW_SUBMISSION_PANEL_FROM_DEAL_TABLE';
export const SET_SELECTED_DEAL_AMOUNT = 'SET_SELECTED_DEAL_AMOUNT';
export const SET_SELECTED_DEAL_COUNT = 'SET_SELECTED_DEAL_COUNT';
export const SET_SELECTED_DEAL_IDS = 'SET_SELECTED_DEAL_IDS';
export const FETCH_PROCESSING_DEALS_STATUS = 'FETCH_PROCESSING_DEALS_STATUS';
export const SET_PROCESSING_DEALS_STATUS = 'SET_PROCESSING_DEALS_STATUS';
export const FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED = 'FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED';
export const FETCH_DEALS_WITH_FORECAST_CATEGORIES_FAILED = 'FETCH_DEALS_WITH_FORECAST_CATEGORIES_FAILED';
export const FETCH_PROPERTIES_STARTED = 'FETCH_PROPERTIES_STARTED';
export const FETCH_PROPERTIES_SUCCEEDED = 'FETCH_PROPERTIES_SUCCEEDED';
export const FETCH_PROPERTY_GROUPS_STARTED = 'FETCH_PROPERTY_GROUPS_STARTED';
export const FETCH_PROPERTY_GROUPS_SUCCEEDED = 'FETCH_PROPERTY_GROUPS_SUCCEEDED';
export const FETCH_PROPERTY_GROUPS_FAILED = 'FETCH_PROPERTY_GROUPS_FAILED';
export const FETCH_DISPLAY_OPTIONS_STARTED = 'FETCH_DISPLAY_OPTIONS_STARTED';
export const FETCH_DISPLAY_OPTIONS_SUCCEEDED = 'FETCH_DISPLAY_OPTIONS_SUCCEEDED';
export const FETCH_PORTAL_SETTINGS_STARTED = 'FETCH_PORTAL_SETTINGS_STARTED';
export const FETCH_PORTAL_SETTINGS_SUCCEEDED = 'FETCH_PORTAL_SETTINGS_SUCCEEDED';
export const FETCH_PORTAL_CONFIG_STARTED = 'FETCH_PORTAL_CONFIG_STARTED';
export const FETCH_PORTAL_CONFIG_SUCCEEDED = 'FETCH_PORTAL_CONFIG_SUCCEEDED';
export const FETCH_MULTI_CURRENCY_STARTED = 'FETCH_MULTI_CURRENCY_STARTED';
export const FETCH_MULTI_CURRENCY_SUCCEEDED = 'FETCH_MULTI_CURRENCY_SUCCEEDED';
export const TOGGLE_IS_AGGREGATED_DEAL_ROLL_UP_FETCHING = 'TOGGLE_IS_AGGREGATED_DEAL_ROLL_UP_FETCHING';
export const TOGGLE_IS_AGGREGATED_GOALS_FETCHING = 'TOGGLE_IS_AGGREGATED_GOALS_FETCHING';
export const TOGGLE_IS_AGGREGATED_SUBMISSIONS_FETCHING = 'TOGGLE_IS_AGGREGATED_SUBMISSIONS_FETCHING';
export const FETCH_AGGREGATED_DEAL_ROLL_UPS_SUCCEEDED = 'FETCH_AGGREGATED_DEAL_ROLL_UPS_SUCCEEDED';
export const FETCH_AGGREGATED_GOALS_SUCCEEDED = 'FETCH_AGGREGATED_GOALS_SUCCEEDED';
export const FETCH_AGGREGATED_SUBMISSIONS_SUCCEEDED = 'FETCH_AGGREGATED_SUBMISSIONS_SUCCEEDED';
export const FETCH_AGGREGATED_DEAL_ROLL_UPS_FAILED = 'FETCH_AGGREGATED_DEAL_ROLL_UPS_FAILED';
export const FETCH_AGGREGATED_GOALS_FAILED = 'FETCH_AGGREGATED_GOALS_FAILED';
export const FETCH_AGGREGATED_SUBMISSIONS_FAILED = 'FETCH_AGGREGATED_SUBMISSIONS_FAILED';
export const FETCH_OPEN_PIPELINE_VALUE_SUCCEEDED = 'FETCH_OPEN_PIPELINE_VALUE_SUCCEEDED';
export const INITIAL_OVERVIEW_DATA_FETCH_SUCCEEDED = 'INITIAL_OVERVIEW_DATA_FETCH_SUCCEEDED';
export const AGGREGATED_OVERVIEW_DATA_FETCH_SUCCEEDED = 'AGGREGATED_OVERVIEW_DATA_FETCH_SUCCEEDED';
export const AGGREGATED_OVERVIEW_DATA_FETCH_FAILED = 'AGGREGATED_OVERVIEW_DATA_FETCH_FAILED';
export const SELECT_TAB = 'SELECT_TAB';
export const SET_FILTER = 'SET_FILTER';
export const SET_REP_OVERVIEW_TABLE_SORT = 'SET_REP_OVERVIEW_TABLE_SORT';
export const FETCH_USER_ATTRIBUTES_STARTED = 'FETCH_USER_ATTRIBUTES_STARTED';
export const SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR = 'SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR';
export const SET_HAS_SEEN_FMO_MIGRATION_TOUR = 'SET_HAS_SEEN_FMO_MIGRATION_TOUR';
export const FETCH_USER_ATTRIBUTES_SUCCEEDED = 'FETCH_USER_ATTRIBUTES_SUCCEEDED';
export const FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED = 'FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED';
export const FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED = 'FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED';
export const SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL = 'SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL';
export const SET_FORECAST_CATEGORIES = 'SET_FORECAST_CATEGORIES';
export const SELECT_PIPELINE = 'SELECT_PIPELINE';
export const SELECT_TIME_PERIOD = 'SELECT_TIME_PERIOD';
export const SET_DEAL_STAGE_MAPPINGS = 'SET_DEAL_STAGE_MAPPINGS';
export const UPDATE_DEAL = 'UPDATE_DEAL';
export const SAVE_DEALS_UPDATES = 'SAVE_DEALS_UPDATES';
export const CANCEL_DEALS_UPDATES = 'CANCEL_DEALS_UPDATES';
export const SET_DEAL_VALIDATION = 'SET_DEAL_VALIDATION';
export const SET_DEAL_COLUMN_WIDTH = 'SET_DEAL_COLUMN_WIDTH';
export const PIPELINE_CADENCES_REQUEST_SUCCEEDED = 'PIPELINE_CADENCES_REQUEST_SUCCEEDED';
export const SET_CURRENT_CADENCE = 'SET_CURRENT_CADENCE';
export const SET_IS_MULTI_CADENCE = 'SET_IS_MULTI_CADENCE';
export const FETCH_PIPELINES_SUCCEEDED = 'FETCH_PIPELINES_SUCCEEDED';
export const FORECAST_SUBMISSION_SUCCEEDED = 'FORECAST_SUBMISSION_SUCCEEDED';
export const FORECAST_SUBMISSION_FAILED = 'FORECAST_SUBMISSION_FAILED';
export const FORECAST_SUBMISSION_INVALID_DEAL_IDS = 'FORECAST_SUBMISSION_INVALID_DEAL_IDS';
export const UPDATE_FORECAST_DISPLAY_VALUE = 'UPDATE_FORECAST_DISPLAY_VALUE';
export const SELECT_TEAM = 'SELECT_TEAM';
export const BUILD_BREADCRUMBS = 'BUILD_BREADCRUMBS';
export const SELECT_DETAIL_VIEW_OWNER = 'SELECT_DETAIL_VIEW_OWNER';
export const GO_TO_TEAM_VIEW = 'GO_TO_TEAM_VIEW';
export const SELECT_DEAL_SIDEBAR_ID = 'SELECT_DEAL_SIDEBAR_ID';
export const DISMISS_NEW_YEAR_ALERT = 'DISMISS_NEW_YEAR_ALERT';
export const DISMISS_EXCHANGE_RATE_ALERT = 'DISMISS_EXCHANGE_RATE_ALERT';
export const DISMISS_AI_FORECASTING_V2_ALERT = 'DISMISS_AI_FORECASTING_V2_ALERT';
export const DISMISS_GOALS_BUG_ALERT = 'DISMISS_GOALS_BUG_ALERT';
export const FETCH_AGGREGATED_GOAL_BREAKDOWN = 'FETCH_AGGREGATED_GOAL_BREAKDOWN';
export const TOGGLE_AGGREGATED_GOAL_BREAKDOWN_FETCHING = 'TOGGLE_AGGREGATED_GOAL_BREAKDOWN_FETCHING ';
export const FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED = 'FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED';
export const FETCH_AI_PROJECTIONS_OPT_IN_STARTED = 'FETCH_AI_PROJECTIONS_OPT_IN_STARTED';
export const FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED = 'FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED';
export const FETCH_AI_PROJECTIONS_OPT_IN_FAILED = 'FETCH_AI_PROJECTIONS_OPT_IN_FAILED';
export const ENABLE_AI_PROJECTIONS_OPT_IN_STARTED = 'ENABLE_AI_PROJECTIONS_OPT_IN_STARTED';
export const ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED = 'ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED';
export const ENABLE_AI_PROJECTIONS_OPT_IN_FAILED = 'ENABLE_AI_PROJECTIONS_OPT_IN_FAILED';
export const FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED = 'FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED';
export const FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED = 'FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED';
export const FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED = 'FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED';
export const FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED = 'FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED';
export const FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED = 'FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED';
export const FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED = 'FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED';
export const FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED = 'FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED';
export const FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED = 'FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED';
export const FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED = 'FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED';
export const FETCH_ACCURACY_PROJECTION_STARTED = 'FETCH_ACCURACY_PROJECTION_STARTED';
export const FETCH_ACCURACY_PROJECTION_SUCCEEDED = 'FETCH_ACCURACY_PROJECTION_SUCCEEDED';
export const FETCH_ACCURACY_PROJECTION_FAILED = 'FETCH_ACCURACY_PROJECTION_FAILED';
export const FETCH_FORECAST_TYPES_STARTED = 'FETCH_FORECAST_TYPES_STARTED';
export const FETCH_FORECAST_TYPES_SUCCEEDED = 'FETCH_FORECAST_TYPES_SUCCEEDED';
export const FETCH_FORECAST_TYPES_FAILED = 'FETCH_FORECAST_TYPES_FAILED';
export const SET_IS_CREATE_FORECAST_TYPE_WIZARD_OPEN = 'SET_IS_CREATE_FORECAST_TYPE_WIZARD_OPEN';
export const FETCH_REP_DEAL_COLUMNS_STARTED = 'FETCH_REP_DEAL_COLUMNS_STARTED';
export const FETCH_REP_DEAL_COLUMNS_SUCCEEDED = 'FETCH_REP_DEAL_COLUMNS_SUCCEEDED';
export const FETCH_REP_DEAL_COLUMNS_FAILED = 'FETCH_REP_DEAL_COLUMNS_FAILED';
export const UPDATE_REP_DEAL_COLUMNS = 'UPDATE_REP_DEAL_COLUMNS';

// Delete Submission Modal
export const OPEN_DELETE_SUBMISSION_MODAL = 'OPEN_DELETE_SUBMISSION_MODAL';
export const CLOSE_DELETE_SUBMISSION_MODAL = 'CLOSE_DELETE_SUBMISSION_MODAL';